import { render, staticRenderFns } from "./Promotionrevenue.vue?vue&type=template&id=d759ae52&scoped=true"
import script from "./Promotionrevenue.vue?vue&type=script&lang=js"
export * from "./Promotionrevenue.vue?vue&type=script&lang=js"
import style0 from "./Promotionrevenue.vue?vue&type=style&index=0&id=d759ae52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d759ae52",
  null
  
)

export default component.exports